import { useRoutes } from 'react-router-dom';
import { lazy } from 'react';
// project import

import Loadable from 'components/Loadable';
import LandingLayout from 'layout/LandingLayout/index';

import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import LandingRoutes from './LandingRoutes';
const KitHome = Loadable(lazy(()=>import('pages/kithome')))

export default function ThemeRoutes() {
  return useRoutes([
    {
      path: '/',
      element: <LandingLayout layout="landing" />,
      children: [
        {
          path: '/',
          element: <KitHome />
        }
      ]
    },
    LandingRoutes,
    MainRoutes,
    LoginRoutes]);
}
